import React from 'react';
import { GoArrowUpRight } from "react-icons/go";

const ButtonPage = ({ text, onClick, type = "button", className = "" }) => {
  return (
    <>
      <button onClick={onClick} className="flex items-center space-x-3 group textactive relative cursor-pointer md:text-xl text-lg capitalize font-semibold w-full">
        <span className="select-none">{text}</span>
        <GoArrowUpRight className="w-5 h-5" />
      </button >
    </>

  );
};

export default ButtonPage;